import React, { useState } from "react";

export default function Success() {
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  const players = [
    {
      name: "Rohan",
      achievement: "Selected for TNPL MADURAI PANTHERS",
      achievementDetails:"he took lead wicket in last year 2025-2026 League",
      videoUrl: "/videos/rohan.mp4",
      image:"/images/rohan.jpeg",
    },
    {
      name: "Rahul",
      achievement: "Playing in TNCA 2nd Division RISING STAR",
      achievementDetails:"Took 25 wickets in last 2025-2026 3rd division league ",
      videoUrl: "/videos/rahul.mp4",
      image:"/images/rahul.jpeg",
    },
    {
      name: "Swadesh B",
      achievement: "Playing in TNCA 2nd Division RISING STAR",     
      achievementDetails:"Leading scorer of tournament 718runs includes(50's-5 & 100's-2) includes 3rd div championship match",
      image:"/images/swadesh1.jpeg"
    },
  ];

  return (
    <section className="p-12 bg-white text-center">
      <h2 className="text-3xl font-bold mb-8 text-[#0B1F3A]">
        Our Academy Players Achievement
      </h2>

      <div className="grid md:grid-cols-3 gap-6">
        {players.map((player, index) => (
          <div
  key={index}
  onClick={() => {
    if (player.videoUrl) {
      setSelectedPlayer(player);
    }
  }}
  className="relative h-80 rounded-xl overflow-hidden shadow-lg cursor-pointer group"
style={{
  backgroundImage: `url(${player.image})`,
  backgroundSize: "70% 100%",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
}}
>
  
  {/* Text */}
 <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
  <h3 className="text-2xl font-bold text-white">
    {player.name}
  </h3>

  <p className="mt-2 font-bold text-white">
    {player.achievement}
     <br />
  <span className="achievement-details  font-bold">
    {player.achievementDetails}
  </span>
  </p>

  {player.videoUrl && (
    <p className="mt-4 text-sm font-semibold text-white">
      ▶ Watch {player.name}'s Video
    </p>
  )}
</div>
</div>
        ))}
      </div>

      {/* Video Modal */}
      {selectedPlayer && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4"
          onClick={() => setSelectedPlayer(null)}
        >
          <div
            className="relative w-auto max-w-3xl bg-black rounded-xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={() => setSelectedPlayer(null)}
              className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white text-black text-xl font-bold"
            >
              ×
            </button>

            <video
              src={selectedPlayer.videoUrl}
              controls
              autoPlay
              className="w-full"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      )}
    </section>
  );
}
